<template>
  <b-modal title="Lista de Templates" v-model="show" size="lg">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE TEMPLATES :::::::::::::::::::::::::::: -->
      <b-table
        id="table-cert-temp"
        bordered
        hover
        small
        head-variant="light"
        :items="getFilterLaudos(filtro)"
        :fields="fields.laudosTemplate"
      >
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="load(data.item)">
              <b-icon icon="file-earmark-arrow-down" variant="info"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <template #modal-footer>
      <b-form inline>
        <b-icon icon="search" variant="primary" scale="1.2" class="m-1" />
        <b-form-input
          id="laudo-filter-tmp"
          type="search"
          size="sm"
          variant="warning"
          class="m-1 p-1"
          placeholder="Modelo"
          v-model="filtro"
        />
      </b-form>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useLaudoTecnicoStore } from "@/stores/LaudoTecnicoStore";
import TableFields from "@/tools/TableFields";
import LaudoTecnico from "@/models_reports/LaudoTecnico";

export default {
  name: "LaudoTecnicoTemplateModal",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      template: new LaudoTecnico(),
      filtro: "",
    };
  },

  methods: {
    load(dados) {
      this.template.id = dados.id;
      this.template.modelo = dados.modelo;
      this.template.seguranca = dados.seguranca;
      this.template.detalhe = dados.detalhe;
      this.template.definicao = dados.definicao;
      this.template.operacional = dados.operacional;
      this.template.mecanica = dados.mecanica;
      this.template.eletrica = dados.eletrica;
      this.template.motor = dados.motor;
      this.template.recomendar = dados.recomendar;
      this.template.conclusao = dados.conclusao;
      this.template.displayMecanica = dados.displaymecanica;
      this.template.displayEletrica = dados.displayeletrica;
      this.template.displayMotor = dados.displaymotor;

      this.laudoTecnicoStore.LISTAR_COMPONENTES(dados.id).then(() => {
        this.template.componentes = this.getComponentes;
      });

      this.laudoTecnicoStore.LISTAR_NORMAS(dados.id).then(() => {
        this.template.normas = this.getNormas;
      });

      this.laudoTecnicoStore.LISTAR_CONDICOES(dados.id).then(() => {
        this.template.condicoes = this.getCondicoes;
      });

      this.laudoTecnicoStore.LISTAR_RISCOS(dados.id).then(() => {
        this.template.riscos = this.getRiscos;
      });

      setTimeout(() => {
        this.laudoTecnicoStore.LISTAR_MECANICOS(dados.id).then(() => {
          this.template.mecanicos = this.getMecanicos;
        });

        this.laudoTecnicoStore.LISTAR_ELETRICOS(dados.id).then(() => {
          this.template.eletricos = this.getEletricos;
        });

        this.laudoTecnicoStore.LISTAR_MOTORES(dados.id).then(() => {
          this.template.motores = this.getMotores;
        });

        this.laudoTecnicoStore.LISTAR_RECOMENDACOES(dados.id).then(() => {
          this.template.recomendacoes = this.getRecomendacoes;
        });
      }, 500);

      setTimeout(() => {
        this.$emit("loadTemplate", this.template);
        this.show = !this.show;
      }, 2500);
    },

    call() {
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const laudoTecnicoStore = useLaudoTecnicoStore();
    const { getLaudos } = storeToRefs(laudoTecnicoStore);
    const { getFilterLaudos } = storeToRefs(laudoTecnicoStore);
    const { getComponentes } = storeToRefs(laudoTecnicoStore);
    const { getNormas } = storeToRefs(laudoTecnicoStore);
    const { getCondicoes } = storeToRefs(laudoTecnicoStore);
    const { getRiscos } = storeToRefs(laudoTecnicoStore);
    const { getMecanicos } = storeToRefs(laudoTecnicoStore);
    const { getEletricos } = storeToRefs(laudoTecnicoStore);
    const { getMotores } = storeToRefs(laudoTecnicoStore);
    const { getRecomendacoes } = storeToRefs(laudoTecnicoStore);

    return {
      store,
      laudoTecnicoStore,
      getLaudos,
      getFilterLaudos,
      getComponentes,
      getNormas,
      getCondicoes,
      getRiscos,
      getMecanicos,
      getEletricos,
      getMotores,
      getRecomendacoes,
    };
  },
};
</script>

<style lang="scss" scoped>
#laudo-filter-tmp {
  width: 22rem;
}
</style>
